export default __webpack_public_path__ + "72216c9b60710214c0e32657b0e53d59.png";